import { GraduationServicePath } from "utils/constants";
import permissions from "app/permissions";
import CreateGroupStateExams from "./Create";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + "state-exams-group",
  title: "Създаване на групов държавен изпит",
  create: <CreateGroupStateExams />,
  permission: permissions.canCreateGroupStateExams,
};
